import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScoreSymbolBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "score-symbol-black_svg__Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1114.3 1020.99",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M363.85,1020.99C216.91,1020.99,99.36,977.03,0,897.62l97.96-154.56c72.77,55.3,165.13,104.93,272.89,104.93s166.53-41.12,166.53-116.28c0-184.35-495.39-48.21-495.39-431.08C41.98,112.03,194.52,0,393.24,0,512.19,0,615.74,26.95,724.9,117.7l-97.96,150.31c-69.97-56.72-146.94-95.01-230.9-95.01-90.96,0-149.74,43.96-149.74,112.02,0,195.69,493.99,53.89,493.99,428.25,0,177.26-132.94,307.71-376.44,307.71Z" }), /* @__PURE__ */ _jsx("path", { d: "M813.76,877.5c0-87.9,64.13-140.65,141.76-140.65s141.77,52.75,141.77,140.65-64.14,140.65-141.77,140.65-141.76-52.74-141.76-140.65Z" })]
});
export default SvgScoreSymbolBlack;
